// A section card that is also a named region. kore's FormSection renders
// <section><header><h2> with no aria-labelledby and takes no aria props, so
// its section has no accessible name and no region role. This wraps it in a
// <section> that carries the id (the section nav's scroll target) and points
// at the title — screen readers get a landmark per section, and tests can
// find a card by its title.

import { FormSection } from "@pej/kore/components";
import type { ReactNode, Ref } from "react";
import { cn } from "@/lib/utils";

export interface SectionCardProps {
    id: string;
    title: ReactNode;
    actions?: ReactNode;
    children: ReactNode;
    /** The section element, e.g. to scroll a new draft into view. */
    ref?: Ref<HTMLElement>;
    /** Extra classes on the section, e.g. a deeper scroll margin under a sticky bar. */
    className?: string;
}

export function SectionCard({ id, title, actions, children, ref, className }: SectionCardProps) {
    const titleId = `${id}-title`;
    return (
        // scroll-mt: a nav click lands the section 72px down, below the
        // compact header and level with the sticky nav (section-page-shell).
        <section ref={ref} id={id} aria-labelledby={titleId} className={cn("scroll-mt-[4.5rem]", className)}>
            <FormSection title={<span id={titleId}>{title}</span>} actions={actions}>
                {children}
            </FormSection>
        </section>
    );
}
